import locationTypes from './types';

export const initialStates = {
	list: null,
	address: null,
	neshanPosition: null,
	locationProvince: [],
	locationCity: [],
	locationDistrict: [],
	locationArea: [],
	pointToLocation: {},
};

const locationReducers = (state = initialStates, action) => {
	switch (action.type) {
		case locationTypes.LIST.SUCCESS: {
			return { ...state, list: action?.payload?.locations };
		}

		case locationTypes.LIST.CLEAR: {
			return { ...state, list: null };
		}

		case locationTypes.NESHAN_POSITION.SUCCESS: {
			return { ...state, neshanPosition: action?.payload };
		}

		case locationTypes.NESHAN_POSITION.CLEAR: {
			return { ...state, neshanPosition: null };
		}

		case locationTypes.POINT_TO_ADDRESS.SUCCESS: {
			return { ...state, address: action?.payload?.data };
		}

		case locationTypes.POINT_TO_ADDRESS.CLEAR: {
			return { ...state, address: null };
		}
		case locationTypes.POINT_TO_LOCATION.SUCCESS: {
			return { ...state, pointToLocation: action?.payload?.data };
		}

		case locationTypes.POINT_TO_LOCATION.CLEAR: {
			return { ...state, pointToLocation: null };
		}

		case locationTypes.LOCATION_PROVINCE.CLEAR: {
			return { ...state, locationProvince: null };
		}
		case locationTypes.LOCATION_PROVINCE.SUCCESS: {
			return { ...state, locationProvince: action?.payload?.data };
		}
		case locationTypes.LOCATION_CITY.CLEAR: {
			return { ...state, locationCity: null };
		}
		case locationTypes.LOCATION_CITY.SUCCESS: {
			return { ...state, locationCity: action?.payload?.data };
		}
		case locationTypes.LOCATION_DISTRICT.CLEAR: {
			return { ...state, locationDistrict: null };
		}
		case locationTypes.LOCATION_DISTRICT.SUCCESS: {
			return { ...state, locationDistrict: action?.payload?.data };
		}
		case locationTypes.LOCATION_AREA.CLEAR: {
			return { ...state, locationArea: null };
		}
		case locationTypes.LOCATION_AREA.SUCCESS: {
			return { ...state, locationArea: action?.payload?.data };
		}
		case locationTypes.LOCATION_GENERAL.RESET: {
			return {
				...state,
				locationProvince: [],
				locationCity: [],
				locationDistrict: [],
				locationArea: [],
			};
		}

		default:
			return state;
	}
};

export default locationReducers;
